import React from "react";
import Text from "../../../../library/text";

import "./style.scss";

const Index = () => {
  return (
    <div className="single-template-right-info-container">
      <h3>Informasjon</h3>
      <Text>
        Du kan navngi malen din slik at du lettere kan holde oversikt dersom du
        benytter deg av flere forskjellige til ulike formål/målgrupper.
      </Text>
    </div>
  );
};

export default Index;
